import ComplianceGapNotice from "src/modules/data-protection/components/ComplianceGapNotice";

const isGapObligation = (obligation) => {
    if (!obligation) {
        return false;
    }

    // Backend marks open gaps with status "gap". If status is absent but
    // a matching obligation was provided as a gap payload, still treat as gap.
    if (obligation.status == null) {
        return true;
    }

    return obligation.status === "gap";
};

const getQuestionSystemData = (question) => {
    if (!question) {
        return null;
    }

    return question.systemData ?? question.system_data ?? null;
};

const getMatchingObligations = (obligationsByCode, systemData) => {
    const matched = obligationsByCode[systemData];

    if (!matched) {
        return [];
    }

    const candidates = Array.isArray(matched) ? matched : [matched];

    return candidates.filter(isGapObligation);
};

/**
 * Creates a QuestionExtension for MultiTabQuestionnaire that shows
 * ComplianceGapNotice when the question's system data matches gap obligation(s).
 *
 * Lookup stays in this wrapper; ComplianceGapNotice only renders.
 *
 * @param {Record<string, Object|Object[]>} obligationsByCode
 * @returns {Function|null}
 */
export const createQuestionnaireGapExtension = (obligationsByCode = {}) => {
    if (
        !obligationsByCode
        || typeof obligationsByCode !== "object"
        || Object.keys(obligationsByCode).length === 0
    ) {
        return null;
    }

    const QuestionnaireGapExtension = (props) => {
        const { question } = props;
        const systemData = getQuestionSystemData(question);

        if (!systemData) {
            return null;
        }

        const obligations = getMatchingObligations(
            obligationsByCode,
            systemData
        );

        if (obligations.length === 0) {
            return null;
        }

        return (
            <ComplianceGapNotice
                obligations={obligations}
            />
        );
    };

    QuestionnaireGapExtension.displayName = "QuestionnaireGapExtension";

    return QuestionnaireGapExtension;
};

export default createQuestionnaireGapExtension;
